import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0096',
    ecrans: ['00-2'],
    params: ['?lemcleint', '?demcleint']
});
